import React, {useState} from 'react';

import './Bars.scss';

// added undefined cause' of TS conflicts
export default ({data, colors, top = false, maxHeight}) => {
  const [toolTip, setToolTip ] = useState(-1);
  const heightLabel = 25;
  maxHeight = maxHeight - heightLabel;
  const maxDataHeight = data.reduce((max, height)=>(Math.max(max, height)), 0);
  const width = `calc(100%/${data.length})`;
  const bars = [];
  data.forEach((height, index)=>{

      bars.push(
        <div className={'sub-menu-tooltip'} style={{display:'inline'}} key={index}>
          <div style={{width: width,
            display: 'inline-block',
            textAlign: 'center',
            verticalAlign: top ? 'top' : 'bottom'
          }}>

            <div style={{
              paddingTop: top ? Math.max(0,((maxHeight*height)/maxDataHeight) - heightLabel )+'px' : 0,
              backgroundColor: colors[index],
              overflow: 'hidden',
              height: (maxHeight * height / maxDataHeight) + 'px',
            }}
                 onMouseOver={()=>setToolTip(index)}
                 onMouseLeave={()=>setToolTip(-1)}
            >
              <label style={{
                fontFamily: 'Roboto Condensed',
                color: 'white',
                fontWeight: 'bold'}}>
                { (100*height)/maxDataHeight > 25 ? height : ''}
              </label>
            </div>
          </div>
          { toolTip === index && (100*height)/maxDataHeight <= 25 ?
            <div className={'sub-menu-tooltip-body-'+(top ? 'bottom' : 'top')}
                 style={top ? {top:((100*height)/maxDataHeight)+'px'} : {bottom:((100*height)/maxDataHeight)+'px'}}>
              {height}
            </div> : null}
        </div>
      );
    }
  );
  return <div style={{width: '100%'}}>
    {bars}
  </div>;
};
